export interface MetricUser {
  emailAddress: string;
  employeeID: string;
  fullName: string;
  lastSeen: Date;
}
